<template>
  <div class="news-detail">
    <!-- 正常显示新闻内容 -->
    <div v-if="item" class="container content">
      <!-- 返回列表 -->
      <div class="back" @click="$router.push('/news')">
        <i class="el-icon-arrow-left"></i> 返回新闻列表
      </div>

      <h1 class="title">{{ item.title }}</h1>

      <!-- 发布时间 + 浏览量 -->
      <div class="meta">
        <span><i class="el-icon-date"></i> {{ dateText(item.created_at) }}</span>
        <span><i class="el-icon-view"></i> 浏览量 {{ item.views }}</span>
      </div>

      <!-- 封面图 -->
      <img v-if="item.cover" class="cover" :src="item.cover" :alt="item.title">

      <!-- 正文：后台用富文本编辑器录入，本身即 HTML，所以用 v-html 渲染 -->
      <div class="article" v-html="item.content || '暂无正文'"></div>
    </div>

    <!-- 加载中 -->
    <div v-else-if="loading" class="container content">
      <el-skeleton :rows="8" animated />
    </div>

    <!-- 内容不存在（已删除或已隐藏） -->
    <div v-else class="container content">
      <el-empty description="该新闻不存在或已被隐藏">
        <el-button type="primary" @click="$router.push('/news')">返回新闻列表</el-button>
      </el-empty>
    </div>
  </div>
</template>

<script>
import { getNewsDetail } from '../api'

export default {
  name: 'NewsDetail',
  data() {
    return {
      loading: true,
      item: null   // 新闻详情，加载失败或不存在时保持 null
    }
  },
  created() {
    this.fetchDetail()
  },
  methods: {
    async fetchDetail() {
      this.loading = true
      try {
        // 路由参数 id：字符串，后端会自动转成数字
        const res = await getNewsDetail(this.$route.params.id)
        this.item = res.data
        // 详情页标题跟随新闻标题，方便分享
        document.title = this.item.title + ' - 示例科技'
      } catch (e) {
        this.item = null
      } finally {
        this.loading = false
      }
    },
    dateText(datetime) {
      return (datetime || '').slice(0, 10)
    }
  }
}
</script>

<style scoped>
.content { padding: 32px 0 60px; }

.back {
  display: inline-block;
  margin-bottom: 20px;
  color: #909399;
  font-size: 14px;
  cursor: pointer;
}
.back:hover { color: #1677ff; }

.title {
  margin: 0 0 16px;
  font-size: 30px;
  line-height: 1.4;
  color: #1f2d3d;
}

.meta {
  display: flex;
  gap: 24px;
  padding-bottom: 20px;
  margin-bottom: 24px;
  border-bottom: 1px solid #ebeef5;
  color: #909399;
  font-size: 14px;
}
.meta i { margin-right: 4px; }

.cover {
  width: 100%;
  max-height: 420px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 24px;
}

/* 正文排版：后台富文本内容没有统一样式，这里补上基础排版 */
.article {
  font-size: 16px;
  line-height: 1.9;
  color: #303133;
  word-break: break-word;
}
.article >>> img { max-width: 100%; height: auto; }
.article >>> p { margin: 0 0 16px; }
.article >>> h1, .article >>> h2, .article >>> h3 { margin: 24px 0 12px; }
</style>
